import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { statLabels } from '@sorare/core/src/lib/scoring';

import { TutorialBezel } from '../../TutorialBezel';
import { Stat } from '../Stat';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: var(--double-unit);
  column-gap: var(--double-and-a-half-unit);
  padding: var(--double-unit);
`;
export const Actions = () => {
  return (
    <TutorialBezel color="var(--c-score-high)">
      <Wrapper className="text-center">
        <Stat
          value={1}
          color="var(--c-score-high)"
          label={<FormattedMessage {...statLabels.points} />}
        />
        <Stat
          value={1.2}
          color="var(--c-score-high)"
          label={<FormattedMessage {...statLabels.rebounds} />}
        />
        <Stat
          value={1.5}
          color="var(--c-score-high)"
          label={<FormattedMessage {...statLabels.assists} />}
        />
        <Stat
          value={3}
          color="var(--c-score-high)"
          label={<FormattedMessage {...statLabels.blocks} />}
        />
        <Stat
          value={3}
          color="var(--c-score-high)"
          label={<FormattedMessage {...statLabels.steals} />}
        />
        <Stat
          value={1}
          color="var(--c-score-high)"
          label={<FormattedMessage {...statLabels.three_points_made} />}
        />
      </Wrapper>
    </TutorialBezel>
  );
};
